import ArrowDownIcon from '@/shared/assets/icons/arrow-down.svg?react';
import ArrowLeftIcon from '@/shared/assets/icons/arrow-left.svg?react';
import ArrowLongLeftIcon from '@/shared/assets/icons/arrow-long-left.svg?react';
import ArrowLongRightIcon from '@/shared/assets/icons/arrow-long-right.svg?react';
import ArrowRightIcon from '@/shared/assets/icons/arrow-right.svg?react';
import ArrowUpIcon from '@/shared/assets/icons/arrow-up.svg?react';
import CalendarIcon from '@/shared/assets/icons/calendar.svg?react';
import CheckIcon from '@/shared/assets/icons/check.svg?react';
import CloseIcon from '@/shared/assets/icons/close.svg?react';
import FolderUsersIcon from '@/shared/assets/icons/folder-users.svg?react';
import FolderVariablesIcon from '@/shared/assets/icons/folder-variables.svg?react';
import FolderIcon from '@/shared/assets/icons/folder.svg?react';
import GoogleIconIcon from '@/shared/assets/icons/google-icon.svg?react';
import HistoryIcon from '@/shared/assets/icons/history.svg?react';
import ListIcon from '@/shared/assets/icons/list.svg?react';
import MagicIcon from '@/shared/assets/icons/magic.svg?react';
import MenuAttributesIcon from '@/shared/assets/icons/menu-attributes.svg?react';
import MenuChecklistsIcon from '@/shared/assets/icons/menu-checklists.svg?react';
import MenuMainIcon from '@/shared/assets/icons/menu-main.svg?react';
import MenuRecordsIcon from '@/shared/assets/icons/menu-records.svg?react';
import MenuRulesIcon from '@/shared/assets/icons/menu-rules.svg?react';
import MenuUsersIcon from '@/shared/assets/icons/menu-users.svg?react';
import PencilIcon from '@/shared/assets/icons/pencil.svg?react';
import PinIcon from '@/shared/assets/icons/pin.svg?react';
import PlusIcon from '@/shared/assets/icons/plus.svg?react';
import PromptIcon from '@/shared/assets/icons/prompt.svg?react';
import SendMessageIcon from '@/shared/assets/icons/send-message.svg?react';
import TrashIcon from '@/shared/assets/icons/trash.svg?react';
import UnpinIcon from '@/shared/assets/icons/unpin.svg?react';
import UserTieIcon from '@/shared/assets/icons/user-tie.svg?react';

const ICON_MAPPING = {
  'arrow-down': ArrowDownIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-long-left': ArrowLongLeftIcon,
  'arrow-long-right': ArrowLongRightIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up': ArrowUpIcon,
  calendar: CalendarIcon,
  check: CheckIcon,
  close: CloseIcon,
  'folder-users': FolderUsersIcon,
  'folder-variables': FolderVariablesIcon,
  folder: FolderIcon,
  'google-icon': GoogleIconIcon,
  history: HistoryIcon,
  list: ListIcon,
  magic: MagicIcon,
  'menu-attributes': MenuAttributesIcon,
  'menu-checklists': MenuChecklistsIcon,
  'menu-main': MenuMainIcon,
  'menu-records': MenuRecordsIcon,
  'menu-rules': MenuRulesIcon,
  'menu-users': MenuUsersIcon,
  pencil: PencilIcon,
  pin: PinIcon,
  plus: PlusIcon,
  prompt: PromptIcon,
  'send-message': SendMessageIcon,
  trash: TrashIcon,
  unpin: UnpinIcon,
  'user-tie': UserTieIcon,
} as const;

export type IconType = keyof typeof ICON_MAPPING;

export default ICON_MAPPING;
